import "../../chunk-D57E6H3M.mjs";

// src/domain/attachments/policy.ts
function checkAttachments(picked, policy, queued = []) {
  if (picked.some((file) => !policy.accept.includes(file.type))) return "unsupported_type";
  if (queued.length + picked.length > policy.maxCount) return "too_many";
  const bytes = [...queued, ...picked].reduce((total, file) => total + file.size, 0);
  return bytes > policy.maxTotalBytes ? "too_large" : null;
}
function formatAcceptedTypes(accept, locale) {
  const names = accept.map((type) => type.split("/").pop().split("+")[0].toUpperCase());
  return new Intl.ListFormat(locale, { type: "disjunction" }).format(names);
}
function formatBytes(bytes, locale) {
  const megabytes = bytes >= 1024 * 1024;
  return new Intl.NumberFormat(locale, { style: "unit", unit: megabytes ? "megabyte" : "kilobyte", unitDisplay: "short", maximumFractionDigits: 1 }).format(bytes / (megabytes ? 1024 * 1024 : 1024));
}
export {
  checkAttachments,
  formatAcceptedTypes,
  formatBytes
};
//# sourceMappingURL=policy.mjs.map